import BadgeCheckSvg from '@assets/images/svg/badge-check.svg';
import React from 'react';
import { View } from 'react-native';

export interface BadgeCheckIconProps {
    size?: number;
    color?: string;
}

export function BadgeCheckIcon({ size = 30, color = 'white' }: BadgeCheckIconProps) {
    return (
        <View style={{ width: size, height: size, justifyContent: 'center', alignItems: 'center' }}>
            <BadgeCheckSvg width={size} height={size} color={color} />
        </View>
    );
}
